import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-return-id";
import * as z from "zod";

const VerifyQuickOutput_ = z.object({
  result: z.enum(["pass", "fail", "unclear"]),
  reasoning: z.string(),
  sourceImageUrls: z.array(z.string()),
  itemTypeMatch: z.boolean().nullable(),
  colorMatch: z.boolean().nullable(),
  brandMatch: z.boolean().nullable(),
});
export const VerifyQuickOutput: z.ZodType<VerifyQuickOutput> =
  VerifyQuickOutput_;
export interface VerifyQuickOutput extends z.infer<typeof VerifyQuickOutput_> {}

export const verifyPhotoQuick = {
  name: "verifyPhotoQuick" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    sessionItemId: processingSessionItemIdFormat.schema,
    photos: z.array(z.string()).min(1),
  }),
  output: VerifyQuickOutput_,
};
